import module from 'nominas/finiquito/module.js'
import template from './template.html'

export class nominasFiniquitoEscenariosItemComponent {
  editable
  data
  onChange
  onDelete
  aplicando = false
  eliminando = false

  $onChanges (changes) {
    if (changes.data) {
      this.data = Object.assign({}, this.data)
    }
  }

  eliminar (eliminado) {
    if (!this.editable) return

    this.eliminando = false

    if (eliminado) {
      this.onDelete({$event: {data: this.data}})
    }
  }

  aplicar (data) {
    if (!this.editable) return

    this.aplicando = false

    if (data) {
      this.data.id_nomina = data.id_nomina
      this.onChange({$event: {detail: this.data}})
    }
  }
}

module.component('nominasFiniquitoEscenariosItem', {
  controller: nominasFiniquitoEscenariosItemComponent,
  template,
  bindings: {
    editable: '<',
    data: '<',
    onChange: '&',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/finiquito/components/escenarios/item/component.js